"use client";

// Client-side wrapper for the Sale Homes Section
// This component fetches homes data using GraphQL after the page loads
// It wraps the SaleHomesSection component with data fetching logic

import { useState, useEffect, useCallback } from "react";
import { Segment } from "../../_shims/semantic-ui-react";
import SaleHomesSectionSimple from "./SaleHomesSectionSimple";
import { getdetailhomelist } from "../../../modules/Graphql/Detailhomegraphql.js";
import {
  getMlslistings,
  getSlipstreamListings,
} from "../../../modules/Graphql/Nhmaphomegraphql.js";

export default function SaleHomesSectionWrapper({
  nhdetails,
  isMobile = false,
}) {
  const [homes, setHomes] = useState([]);
  const [heart, setHeart] = useState({});
  const [activePage2, setActivePage2] = useState(1);
  // const [isLoading, setIsLoading] = useState(true);

  const getNhHomesList = useCallback(() => {
    if (!nhdetails || nhdetails.length === 0) {
      // setIsLoading(false);
      return;
    }

    const data = nhdetails[0];
    if (!data?.geometry_cords || data.geometry_cords.length === 0) {
      // setIsLoading(false);
      return;
    }

    let geo_cords = data.geometry_cords[0];
    let newdata = JSON.parse(geo_cords);
    let datas = [];
    let reservdedata = newdata.map((item2, index2) => {
      datas.push(item2.y + " " + item2.x);
    });
    let finallatlng = datas.reverse().toString();
    let appdata = { coordinate: finallatlng, page: "nhmap" };
    const getdatanew = {
      appdata,
    };

    //For Database listings
    let dbdatas = [];
    let dbreservdedata = newdata.map((item2, index2) => {
      dbdatas.push(item2.x + " " + item2.y);
    });

    let dbfinaldata = dbdatas.toString();
    const dbgetdatanew = {
      start: 0,
      limit: 50,
      orderBy: "OnMarketDate",
      order: dbfinaldata,
      fields: [
        {
          name: "neighborhoodId",
          value: "",
          operator: "!=",
        },
      ],
    };

    Promise.all([
      getMlslistings(getdatanew),
      getdetailhomelist(dbgetdatanew),
      getSlipstreamListings(getdatanew),
    ])
      .then((result) => {
        let righthomedata = [];

        // Add MLS Listings if available
        if (
          result[0]?.data?.getMlslistings &&
          Array.isArray(result[0].data.getMlslistings)
        ) {
          righthomedata.push(...result[0].data.getMlslistings);
        }

        // Add Detailed Home Listings if available
        if (
          result[1]?.data?.getdetailhome &&
          Array.isArray(result[1].data.getdetailhome) &&
          result[1].data.getdetailhome.length > 0
        ) {
          righthomedata.push(...result[1].data.getdetailhome);
        }

        // Add Slipstream Listings if available
        if (
          result[2]?.data?.getSlipstreamListings &&
          Array.isArray(result[2].data.getSlipstreamListings)
        ) {
          righthomedata.push(...result[2].data.getSlipstreamListings);
        }

        // Update state with home data
        setHomes(righthomedata);
        // setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching home listings:", error);
        // setIsLoading(false);
      });
  }, [nhdetails]);

  useEffect(() => {
    if (nhdetails && nhdetails.length > 0) {
      getNhHomesList();
    }
  }, [nhdetails, getNhHomesList]);

  const onSaveHeart = (listingKey) => {
    // Handle save heart functionality
    setHeart((prev) => ({
      ...prev,
      [listingKey]: !prev[listingKey],
    }));
  };

  const togglePrev = (_e, { value }, _id) => {
    // Handle pagination change - extract activePage from value object
    if (value && value.activePage) {
      setActivePage2(value.activePage);
    }
  };

  const checkIfImageExists = (url) => {
    // Simple image existence check
    return true;
  };

  // // Don't render anything if no homes or still loading
  // if (isLoading) {
  //   return (
  //     <Segment
  //       basic
  //       className="home_sales_nh"
  //       style={{ paddingLeft: 0, paddingRight: 0 }}
  //     >
  //       <div style={{ textAlign: "center", padding: "40px" }}>
  //         <p>Loading homes for sale...</p>
  //       </div>
  //     </Segment>
  //   );
  // }

  if (!homes || homes.length === 0) {
    return null;
  }

  return (
    <Segment
      basic
      className="home_sales_nh"
      style={{ paddingLeft: "13px", paddingRight: 0, paddingBottom: 0 }}
    >
      <SaleHomesSectionSimple
        isMobile={isMobile}
        homes={homes}
        heart={heart}
        onSaveHeart={onSaveHeart}
        togglePrev={togglePrev}
        activePage2={activePage2}
        checkIfImageExists={checkIfImageExists}
      />
    </Segment>
  );
}
